import { PageFields } from '@tribeplatform/gql-client/graphql'
import { Page } from '@tribeplatform/gql-client/types'
import { useRouterPath } from '@tribeplatform/react-sdk'
import { useCachedSpace, usePage } from '@tribeplatform/react-sdk/hooks'
import { UseQueryOptions } from '@tribeplatform/react-sdk/lib'
import { decodeURIPath } from '@tribeplatform/react-sdk/utils'

import { isHomePath } from '../utils/url.utils.js'

export const useCurrentPage = (options?: {
  fields?: PageFields
  useQueryOptions?: UseQueryOptions<Page>
}) => {
  const pathname = useRouterPath()
  let path: string
  try {
    path = decodeURIPath(pathname)
  } catch (e) {
    path = pathname
  }

  const isHome = isHomePath(path)

  const cachedSpace = useCachedSpace({ path })

  const page = usePage({
    variables: { path },
    fields: options?.fields,
    useQueryOptions: {
      enabled: !cachedSpace?.slate || !cachedSpace?.seoDetail,
      notifyOnChangeProps: ['data', 'error', 'isInitialLoading'],
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      ...(options?.useQueryOptions ?? {}),
    },
  })

  const data = (() => {
    if (isHome) {
      /**
       * The cachedSpace variable won't match the home space, and the
       * homepage query will have the data cached from the server
       */
      return page.data
    }
    if ((!page.data || page.isPreviousData) && cachedSpace) {
      return { space: cachedSpace } as Page
    }
    return page.data
  })()

  return {
    ...page,
    data,
  }
}
